/* eslint-disable import/first, import/imports-first, import/order */
// BS needs to be imported before React and other imports:
// https://docs.bugsnag.com/platforms/browsers/react/#bundled
import BugsnagErrorBoundary from 'dpl/components/BugsnagErrorBoundary';

import React from 'react';

import initDevHooks from 'dpl/util/initDevHooks';

if (CONFIG.isDevelopment) {
  // eslint-disable-next-line global-require
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React);

  initDevHooks();
}

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getRandomStr } from 'dpl/util';
import createReduxStore from 'dpl/util/createReduxStore';

export default function initReactApp(components = {}) {
  // allow us to reuse redux store across multiple packs
  let reduxStore = window.__DPL_REDUX_STORE;

  if (!reduxStore) {
    reduxStore = createReduxStore();
    window.__DPL_REDUX_STORE = reduxStore;

    if (!CONFIG.isProduction) {
      reduxStore.subscribe(() => {
        if (reduxStore.getState().connect.isAllFetched) {
          document.body.setAttribute('data-test-tpt-connect-all-fetched', true);
        }
      });
    }
  }

  window.__DPL_DEBUG_SESSION_ID || (window.__DPL_DEBUG_SESSION_ID = getRandomStr());

  function createComponentTree(Component) {
    return (
      <BugsnagErrorBoundary>
        <Provider store={ reduxStore }>
          <Component />
        </Provider>
      </BugsnagErrorBoundary>
    );
  }

  Object.entries(components).forEach(([name, Component]) => {
    [...document.querySelectorAll(`[data-react-mount-component="${name}"]`)].forEach((mountEl) => {
      ReactDOM.render(createComponentTree(Component), mountEl);
    });
  });
}

/* eslint-enable import/first, import/imports-first */
